import React from 'react';
import {
    DropdownItemProps,
    Icon,
} from '@instinet-analytics/semantic-ui-components';
import {
    EnumMap,
    enumMapToDropdownOptions as enumMapToDropdownOptionsCore,
    getEnumValue,
} from '@instinet-analytics/core-lib';
import './PillInput.scss';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import classNames from 'classnames';

interface PillDropdownProps {
    className?: string;
    pills: string[];
    options: string[];
    onPillsChanged: (pills: string[]) => void;
    placeholder?: string | string[];
    enumMap?: EnumMap;
}

export default function PillDropdown(props: PillDropdownProps) {
    const {
        className,
        pills,
        onPillsChanged: onParentPillsChanged,
        options: optionsProps,
        placeholder,
        enumMap,
    } = props;

    const onPillsChanged = (pills: string[]) => {
        onParentPillsChanged(pills.filter((p) => !!p));
    };

    const onChange = (selectedValue: string) => {
        onPillsChanged([...pills, selectedValue]);
    };

    const onRemovePill = (index: number) => {
        pills.splice(index, 1);
        onPillsChanged([...pills]);
    };

    const dummyValue = 'DummySelect';

    const onDropdownChange = (nextValue: string) => {
        if (nextValue === dummyValue) {
            return;
        }

        onChange(nextValue);
    };

    const options: DropdownItemProps[] = enumMap
        ? [
              { text: placeholder, value: dummyValue },
              ...enumMapToDropdownOptions(enumMap, true, pills),
          ]
        : [
              { text: placeholder, value: dummyValue },
              ...optionsProps
                  .filter((c) => pills.indexOf(c) === -1)
                  .map((c) => ({ value: c, text: c })),
          ];

    const displayInput = options.length > 1;

    const cssClasses = classNames('PillDropdown', className);
    return (
        <div className={cssClasses}>
            <ul className="pills">
                {pills.map((p, i) => (
                    <li key={i} className="pill">
                        {enumMap ? getEnumValue(enumMap, p) : p}
                        <div
                            className="pill-delete"
                            onClick={() => onRemovePill(i)}
                        >
                            <Icon className="action" name="close" />
                        </div>
                    </li>
                ))}

                {displayInput && (
                    <li className="pending">
                        {
                            <Dropdown
                                onChange={onDropdownChange}
                                options={options}
                                value={dummyValue}
                            />
                        }
                    </li>
                )}
            </ul>
        </div>
    );
}

function enumMapToDropdownOptions(
    enumMap: EnumMap,
    sortByText: boolean,
    selectedValues: string[]
): Array<{
    key: string;
    value: boolean | number | string;
    text: string;
}> {
    const options = enumMapToDropdownOptionsCore(enumMap, sortByText);
    return options.filter((o) => selectedValues.indexOf(o.key) === -1);
}
